const recordData = state => state.recordData

export default {
  recordData
}